import { FDealType, FOfferType } from '../category';

export function getIsSaleBusinessOffer(dealType: FDealType, offerType: FOfferType): boolean {
  return offerType === FOfferType.Business && dealType === FDealType.Sale;
}
